import Store from 'lightningjs-redux';
import { navigateTo, HOME_PATH, PAIRING_PATH, navigateToExpiredSubscriptionPage } from '../../routes/routes.utils';
import { sendEvent } from '../../../logic/analytics/analytics.utils';
import { setUnpairedEntering } from '../../../logic/pairing/pairing.actions';

export * from './customer/default/landingButtons.constants';

export const ENTER = {
  id: 'Enter',
  label: 'pairing.landing.enter',
  action: () => {
    // eslint-disable-next-line no-console
    console.log('[Landing] Handling ENTER action');
    navigateTo(HOME_PATH);
    Store.dispatch(setUnpairedEntering());
  },
  event: () => {},
};

export const SIGN_ON = {
  id: 'SignOnButton',
  label: 'pairing.landing.signOn',
  ref: 'SignOnButton',
  action: () => navigateToExpiredSubscriptionPage(),
  event: () => sendEvent({ key: 'pressSubscribeButton' }),
};

export const SIGN_IN = {
  id: 'SignInButton',
  label: 'pairing.landing.signIn',
  action: () => navigateTo(PAIRING_PATH),
  event: () => sendEvent({ key: 'pressConnectButton' }),
};
